import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import AuthModal from './AuthModal';
import './NavBar.css';

const NavBar = () => {
  const loc = useLocation();
  const navigate = useNavigate(); // <-- כאן
  const isActive = (p) => (loc.pathname === p ? 'nav-link active' : 'nav-link');

  const { user, logout } = useUser();
  const [showAuth, setShowAuth] = useState(false);

  return (
    <header className="nav-bar">

      {/* right: logo */}
      <div className="nav-right">
        <Link to="/" className="logo-link">
          <img src="/לוגו שוכב.png" alt="logo" />
        </Link>
      </div>
      {/* center: navigation */}
      <nav className="nav-center">
          <Link to="/" className={isActive('/')}> 
            <span className="nav-text">דף הבית</span>
            <span className="nav-icon">♡</span>
          </Link>
          <Link to="/branding" className={isActive('/branding')}>
            <span className="nav-text">מיתוגים</span>
            <span className="nav-icon">♡</span>
          </Link>
          <Link to="/programs" className={isActive('/programs')}>
            <span className="nav-text">תוכניות</span>
            <span className="nav-icon">♡</span>
          </Link>
          <Link to="/blog" className={isActive('/blog')}>
            <span className="nav-text">בלוג</span>
            <span className="nav-icon">♡</span>
          </Link>
          <Link to="/profile/cart" className={isActive('/profile/cart')}>
            <span className="nav-text">סל קניות</span>
            <span className="nav-icon">♡</span>
          </Link>
      </nav>
      {/* left: user box */}
      <div className="nav-left">
        <div
          className="user-box"
          onClick={() => {
            if (user) {
              navigate('/profile');
            } else {
              setShowAuth(true);
            }
          }}
          title={user ? 'לאזור האישי' : 'מכאן מתחברים'}
        >
          <div className="user-avatar">{user ? user.name?.[0] || '🙂' :  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="7" r="4"/>
  <path d="M5.5 21c0-3 5-4.5 6.5-4.5s6.5 1.5 6.5 4.5"/>
</svg>}</div>
          <div className="user-text">{user ? 'אזור אישי' : 'מכאן מתחברים'}</div>
        </div>
      </div>


      {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
    </header>
  );
};

export default NavBar;
